<template>
  <span>
    <link href="https://fonts.googleapis.com/css?family=Montserrat:300,400,700" rel="stylesheet" Content-Type="text/css">	
    <!-- Animate.css -->
    <link rel="stylesheet" :href="LOCAL_HOST+'/ThemeMegazine/css/animate.css'" Content-Type="text/css">
    <!-- Icomoon Icon Fonts-->
    <link rel="stylesheet" :href="LOCAL_HOST+'/ThemeMegazine/css/icomoon.css'" Content-Type="text/css">
    <!-- Bootstrap  -->
    <link rel="stylesheet" :href="LOCAL_HOST+'/ThemeMegazine/css/bootstrap.css'" Content-Type="text/css">
    <!-- Flexslider  -->
    <link rel="stylesheet" :href="LOCAL_HOST+'/ThemeMegazine/css/flexslider.css'" Content-Type="text/css">
    <!-- Magnific Popup -->
    <link rel="stylesheet" :href="LOCAL_HOST+'/ThemeMegazine/css/magnific-popup.css'" Content-Type="text/css">
    <!-- Owl Carousel -->
    <link rel="stylesheet" :href="LOCAL_HOST+'/ThemeMegazine/css/owl.carousel.min.css'" Content-Type="text/css">
    <link rel="stylesheet" :href="LOCAL_HOST+'/ThemeMegazine/css/owl.theme.default.min.css'" Content-Type="text/css">
    <!-- Theme style  -->
    <link rel="stylesheet" :href="LOCAL_HOST+'/ThemeMegazine/css/style.css'" Content-Type="text/css">
    <link v-if="RTL_LANG.includes(lang_id)" rel="stylesheet" :href="LOCAL_HOST+'/ThemeMegazine/css/arabic-support.css'">
    <skip-to-main-content></skip-to-main-content>
    <!--<accept-cookies-popup/>-->
  </span>
</template>
<script>
import axios from 'axios';
import SkipToMainContent from '@/components/ThemeMegazine/pages/partialsCommon/SkipToMainContent';
//import AcceptCookiesPopup from '@/components/ThemeMegazine/pages/partialsCommon/AcceptCookiesPopup';
import {weglot_ary} from '@/constants/general_constants';
export default {
    name: 'Header',
    data(){
      return{ LOCAL_HOST:this.$store.state.LOCAL_HOST,lang_id:localStorage.id_language,CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,RTL_LANG:this.$store.state.RTL_LANG }
    },
    components:{
      SkipToMainContent,
      //AcceptCookiesPopup
    },
    mounted(){
      this.checkScript();
      //this.loadExternalJsScript(this.CONTENT_DOMAIN+"/new_eesite_forms/ganalytics/gAnalytics_"+localStorage.id_company+".js");
      this.loadExternalJsScript(this.LOCAL_HOST+"/js/main_global.js");
      this.checkWeglot();
      if(this.$store.state.themeLogic.additional_flag.add_custom_chat){
        this.addCustomChatScript();
      }
    },
    methods:{
      checkScript() { 
        axios.get(this.CONTENT_DOMAIN+"/new_eesite_forms/ganalytics/gAnalytics_"+localStorage.id_company+".php",{  
          })
        .then(response => {
            this.loadExternalJsScript(this.CONTENT_DOMAIN+"/new_eesite_forms/ganalytics/gAnalytics_"+localStorage.id_company+".php");     
          })
        .catch((error) => {
            axios.get(this.CONTENT_DOMAIN+"/new_eesite_forms/ganalytics/gAnalytics_"+localStorage.id_eap+".php",{  
              })
            .then(response => {
                this.loadExternalJsScript(this.CONTENT_DOMAIN+"/new_eesite_forms/ganalytics/gAnalytics_"+localStorage.id_eap+".php");     
              })
            .catch((error) => {
                this.loadExternalJsScript(this.CONTENT_DOMAIN+"/new_eesite_forms/ganalytics/general_cookie_consent.php");
                //this.customErrorHandler(error.response.status);
              });
          });
      },
      checkWeglot(){
        //console.log('inside checkweglot');
        let ary_key = Object.keys(weglot_ary);
        if(ary_key.includes(localStorage.id_language)){
          //console.log('inside its weglot lang');
          if (Weglot) {
              //console.log('weglot is already exists');
              if(localStorage.wglang!=weglot_ary[localStorage.id_language]){
                //console.log('Set weglot lang to ',weglot_ary[localStorage.id_language]);
                Weglot.switchTo(weglot_ary[localStorage.id_language]);
              }              
          }              
        } else {
          //console.log('Its not weglot lang');
          if (Weglot) {
            if(localStorage.wglang!='en'){
              //console.log('Set weglot lang to en');
              Weglot.switchTo('en');
              //console.log('Set dom lang to ',localStorage.lang_abbrevation);
              document.documentElement.setAttribute("lang", localStorage.lang_abbrevation);
            }
          }
        }
      },
      addCustomChatScript() {
        axios.get(this.CONTENT_DOMAIN+"/new_eesite_forms/chat_custom_scripts/chat_custom_"+localStorage.id_company+".php",{  
          })
        .then(response => {
            this.loadExternalJsScript(this.CONTENT_DOMAIN+"/new_eesite_forms/chat_custom_scripts/chat_custom_"+localStorage.id_company+".php");    
          })
        .catch((error) => {
            axios.get(this.CONTENT_DOMAIN+"/new_eesite_forms/chat_custom_scripts/chat_custom_"+localStorage.id_eap+".php",{  
              })
            .then(response => {
                this.loadExternalJsScript(this.CONTENT_DOMAIN+"/new_eesite_forms/chat_custom_scripts/chat_custom_"+localStorage.id_eap+".php");    
              })
            .catch((error) => {                
                //this.customErrorHandler(error.response.status);
              });
          });
      }
    }    
};
</script>